export default __webpack_public_path__ + "static/media/conekta.91a1ed00.png";